(function() {
  function getOptionWrapper(picker, input) {
    if (input.closest('label')) return input.closest('label');
    if (input.id && picker) {
      var label = picker.querySelector('label[for="' + CSS.escape(input.id) + '"]');
      if (label) return label;
    }
    return input.nextElementSibling && input.nextElementSibling.matches && input.nextElementSibling.matches('label') ? input.nextElementSibling : null;
  }

  function fixDisabledSelection(picker) {
    if (!picker) return;
    picker.querySelectorAll('input[data-option-position]:checked').forEach(function(checked) {
      var wrapper = getOptionWrapper(picker, checked);
      if (!wrapper || !wrapper.classList.contains('is-disabled')) return;
      var group = picker.querySelectorAll('input[name="' + checked.name + '"]');
      for (var i = 0; i < group.length; i++) {
        var inp = group[i];
        var w = getOptionWrapper(picker, inp);
        if (w && !w.classList.contains('is-disabled')) {
          inp.checked = true;
          inp.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        } 
      }
    });
  }

  function run() {
    document.querySelectorAll('variant-picker').forEach(fixDisabledSelection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
